import type {
    CompleteCommerceCheckoutRequest,
    CompleteCommerceCheckoutResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";

export const completeCommerceCheckoutOperation = defineCommerceOperation<
    CompleteCommerceCheckoutRequest,
    CompleteCommerceCheckoutResponse
>("commerce.checkout.complete");
